// src/App.js
import React, { useState } from 'react';
import { ThemeProvider, Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer';
import { PathContext } from './contexts/PathContext';
import { customTheme } from './theme';
import './App.css';

import Header from './components/Header';
import BreadcrumbNav from './components/BreadcrumbNav';
import FileBrowser from './components/FileBrowser';
import Footer from './components/Footer';

/** IdleLogout component logs out after 60m inactivity */
function IdleLogout() {
  const { signOut } = useAuthenticator(context => [context.signOut]);

  const handleOnIdle = () => {
    // Perform a global sign-out to revoke tokens
    signOut({ global: true });
    window.location.reload();
  };

  useIdleTimer({
    timeout: 1000 * 60 * 60, // 60 minutes
    onIdle: handleOnIdle,
    debounce: 500
  });

  return null;
}

export default function App() {
  const [path, setPath] = useState('');

  // Google OAuth configuration
  const federatedConfig = {
    googleClientId: 'YOUR_GOOGLE_CLIENT_ID.apps.googleusercontent.com'
  };

  // Override parts of the Amplify UI
  const components = {
    Header() {
      return (
        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
          <img src="logo.png" alt="Logo" style={{ height: '120px' , margin:'20px' }} />
        </div>
      );
    },
    SignIn({ fields, handleSubmit, updateForm, submitButtonText, error }) {
      return (
        <form onSubmit={handleSubmit} style={{ maxWidth: 300, margin: 'auto' }}>
          {fields.map(field => (
            <fieldset key={field.labelText} style={{ marginBottom: '1rem' }}>
              {field.type !== 'hidden' && (
                <label htmlFor={field.inputProps.id} style={{ display: 'block', marginBottom: 4 }}>
                  {field.labelText}
                </label>
              )}
              <field.InputField
                {...field.inputProps}
                onChange={e => updateForm(e.target.value, field.inputProps.id)}
                style={{ width: '100%', padding: 8 }}
              />
            </fieldset>
          ))}
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            {submitButtonText}
          </button>
          {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
        </form>
      );
    }
  };

  return (
    <ThemeProvider theme={customTheme}>
      <IdleTimerProvider>
        <Authenticator
          hideSignUp={false}
          socialProviders={['google']}
          federated={federatedConfig}
          components={components}
        >
          {({ signOut: authSignOut, user }) => (
            <PathContext.Provider value={{ path, setPath }}>
              {/* IdleLogout listens for inactivity */}
              <IdleLogout />

              <div className="app-container">
                <Header user={user} onSignOut={authSignOut} />

                <main>
                  <BreadcrumbNav />
                  <FileBrowser onSignOut={authSignOut} />
                </main>

                <Footer />
              </div>
            </PathContext.Provider>
          )}
        </Authenticator>
      </IdleTimerProvider>
    </ThemeProvider>
  );
}
